<!-- Edit caller unavailable warning -->
@if (editUnavailable) {
	<div class="warning-message m-bottom-big">
		<mat-icon>info_outline</mat-icon>
		<span>{{ I18N.FEEDBACK_EDIT_UNAVAILABLE | i18n | async }}</span>
	</div>
}

<!-- Rating Section -->
<div class="highlight cft-border-blue container-p m-bottom-big">
	<p class="font--bold m-bottom-mid">{{ I18N.FEEDBACK_THANK_YOU | i18n | async }}</p>
	<p class="font--small m-bottom-big">{{ I18N.FEEDBACK_INFO_TEXT | i18n | async }}</p>

	<mat-label class="font--small-bold">{{ I18N.FEEDBACK_RATING_LABEL | i18n | async }}</mat-label>
	<div class="rating-icons m-top-mid">
		@for (rating of ratings; track rating.value) {
			<button
				class="rating-btn"
				[class.selected]="currentRating() === rating.value"
				[class.read-only]="isReadOnly()"
				(click)="onRatingClick(rating.value)"
				[disabled]="isReadOnly()"
				[attr.aria-label]="rating.i18nKey | i18n | async"
				[attr.aria-pressed]="currentRating() === rating.value"
			>
				<mat-icon
					[svgIcon]="currentRating() === rating.value ? rating.iconSelected : rating.icon"
					class="rating-icon"
				></mat-icon>
				<span class="rating-label font--subtitle--small">{{ rating.i18nKey | i18n | async }}</span>
			</button>
		}
	</div>
</div>

<!-- Detailed Feedback Section -->
@if (currentRating() > 0) {
	<div class="highlight cft-border-blue container-p m-bottom-big" [formGroup]="form">
		<!-- Negative aspects checkboxes (only for ratings < 4) -->
		@if (!isPositive()) {
			<div class="checkboxes-section m-bottom-big">
				<mat-label class="font--small-bold m-bottom-mid">{{ I18N.FEEDBACK_NEGATIVE_ASPECTS | i18n | async }}</mat-label>
				<mat-checkbox formControlName="wrongNameOrCompany">
					{{ I18N.FEEDBACK_CB_WRONG_NAME | i18n | async }}
				</mat-checkbox>
				<mat-checkbox formControlName="wrongTelephoneNumber">
					{{ I18N.FEEDBACK_CB_WRONG_PHONE | i18n | async }}
				</mat-checkbox>
				<mat-checkbox formControlName="wrongNotice">
					{{ I18N.FEEDBACK_CB_WRONG_NOTICE | i18n | async }}
				</mat-checkbox>
				<mat-checkbox formControlName="unfriendlyCall">
					{{ I18N.FEEDBACK_CB_UNFRIENDLY | i18n | async }}
				</mat-checkbox>
				<mat-checkbox formControlName="ordersIgnored">
					{{ I18N.FEEDBACK_CB_ORDERS_IGNORED | i18n | async }}
				</mat-checkbox>
			</div>
		}

		<!-- Comment -->
		<mat-form-field appearance="outline" class="comment-field m-bottom-mid">
			<textarea
				matInput
				formControlName="customerAnnotation"
				cdkTextareaAutosize
				cdkAutosizeMinRows="3"
				cdkAutosizeMaxRows="8"
				[placeholder]="(I18N.FEEDBACK_COMMENT_PLACEHOLDER | i18n | async) ?? ''"
			></textarea>
		</mat-form-field>

		<!-- Callback Wish -->
		<div class="callback-wish-section m-bottom-mid">
			<mat-slide-toggle formControlName="contactWish">
				<span class="m-left-mid">{{ I18N.FEEDBACK_CALLBACK_WISH | i18n | async }}</span>
			</mat-slide-toggle>

			@if (form.controls.contactWish.value) {
				<p class="font--small m-top-mid">{{ I18N.FEEDBACK_CALLBACK_PHONE_HINT | i18n | async }}</p>
				<mat-form-field appearance="outline" class="phone-field m-top-mid">
					<mat-label>{{ I18N.FEEDBACK_CALLBACK_PHONE | i18n | async }}</mat-label>
					<input matInput formControlName="callbackPhoneNumber" type="tel" />
					@if (form.controls.callbackPhoneNumber.hasError('maxlength')) {
						<mat-error>{{ I18N.ERROR_MAX_LENGTH | i18n | async }}</mat-error>
					} @else if (form.controls.callbackPhoneNumber.hasError('pattern')) {
						<mat-error>{{ I18N.ERROR_REQUIRED | i18n | async }}</mat-error>
					}
				</mat-form-field>
			}
		</div>
	</div>

	<!-- Error message -->
	@if (saveError()) {
		<div class="error-message m-bottom-mid" role="alert">
			<mat-icon>error_outline</mat-icon>
			<span>{{ I18N.FEEDBACK_SAVE_ERROR | i18n | async }}</span>
		</div>
	}

	<!-- Action bar / Success -->
	@if (!detailedSaved()) {
		<div class="action-bar flex-r">
			<button
				(click)="submitDetailedFeedback()"
				[disabled]="savingDetailed() || isReadOnly()"
				class="submit-btn"
				matButton="filled"
			>
				{{ I18N.FEEDBACK_SUBMIT | i18n | async }}
			</button>
		</div>
	} @else {
		<div class="success-message cft-border p-mid m-top-mid" role="status">
			<p class="font--brand font--bold">{{ I18N.FEEDBACK_SAVED_SUCCESS | i18n | async }}</p>
		</div>
	}
}
